import React from "react";
import style from "./index.module.scss";

interface ListStaticsProps {
    id: number;
    allCount: number; //总人数
    noJudgeCount: number; //未批阅
    judgeCount: number; //已批阅
    noJoinIn: number; //未参与
    gotoDetail: (exerciseId: number, params?: StringMap) => void;
}

export default function ListStatics({
    id,
    allCount,
    noJudgeCount,
    judgeCount,
    noJoinIn,
    gotoDetail
}: ListStaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={style.item}
                onClick={() => gotoDetail(id, { status: "all" })}>
                {allCount}
                <br />
                <span>总组数</span>
            </div>
            <div
                className={style.item}
                onClick={() => gotoDetail(id, { status: "judged" })}>
                {judgeCount}
                <br />
                <span>已批阅</span>
            </div>
            <div
                className={style.item}
                onClick={() => gotoDetail(id, { status: "noJudge" })}>
                {noJudgeCount}
                <br />
                <span>待批阅</span>
            </div>
            <div
                className={style.item}
                onClick={() => gotoDetail(id, { status: "noJoinIn" })}>
                {noJoinIn}
                <br />
                <span>未参与</span>
            </div>
        </div>
    );
}

ListStatics.defaultProps = {
    exerciseAllCount: 0,
    noJudgeCount: 0,
    judgeCount: 0,
    noJoinInExerciseCount: 0
};
